<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.query.templateId == undefined" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.templateId == undefined">

      <template v-slot:list>
        <SelectableListPane :getListMethod="getCheckListTemplatesFromFilter" :optional-filters="filters"
          :lockedFilters="lockedFilters" :paginationEnabled="true" :show-filter-tab="false" :show-sorting-tab="false"
          :itemsPerPage="100" :open-function="openItem" :dialog-trigger="dialogtrigger" :dialogItem="editItem"
          :multiple="false" :previewable="true" :dialog-method-config="dialogMethodConfig" :pk="pk" ref="ListPane"
          @Added="item => openItem(item)" @select="val => select(val)" @openPreview="item => openPreview(item)"
          @closePreview="closePreview()">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)" />
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <v-container v-if="item" :key="trigger">
              <v-row no-gutters>
                <v-col cols="12">
                  <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.commonterms.name')"
                    :rules="[requiredRule]" externaledit>
                  </QTextField>
                </v-col>
                <v-col cols="12" class="my-3">
                  <QAutoComplete v-model="item.TemplateType" :label="'Type'" :list="templateTypes" :textkey="'text'"
                    :valuekey="'value'" externaledit>
                  </QAutoComplete>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <!--
          <template
            v-slot:select-actions="{ selectionFilter, filter, selectMethod, clearSelectionMethod, refreshListMethod }">
            <MachineSelectionOptions :selectionFilter="selectionFilter" :filter="filter" :selectMethod="selectMethod"
              :customerId="customerId" :clearSelectionMethod="clearSelectionMethod"
              :refreshListMethod="refreshListMethod" hideSetPropperties
              :selectText="$t('servicesystem.common_objects.commonterms.set_propperties')" ref="selectionOptions">
            </MachineSelectionOptions>
          </template>
           -->

        </SelectableListPane>
      </template>

      <template v-slot:preview>
        <PreviewPane :id="$route.query.templateId" :closePreview="() => { closePreview(); resetPreviewIndex(); }">
        </PreviewPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ListItem from "@/components/ListItems/CheckListTemplateListItem.vue";
import SelectableListPane from "@/views/pim/articles/SelectableListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";
import CheckListConstants from "@/helpers/Constants/CheckListConstants";
import PreviewPane from "@/components/Sections/Panes/PreviewCheckListTemplate.vue";

export default {
  name: "AdminCheckListTemplates",
  props: {
    pk: {
      type: String,
      default: "CKL-",
    },
    lockedFilters: Object,
  },
  components: {
    SelectableListPane,
    Layout,
    ListItem,
    PreviewPane,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      newItemInitial: { Id: 0, Name: "", TemplateType: 1 },
      editItem: null,
      dialogtrigger: 1,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createCheckList',
        },
      },
      templateTypes: Object.keys(CheckListConstants.templateTypes).map(key => ({
        value: parseInt(key),
        text: CheckListConstants.templateTypes[key].text
      }))
    };
  },


  methods: {
    select() {
      console.error('Not implemented');
    },

    resetPreviewIndex() {
      var listPane = this.$refs.ListPane;
      listPane.setPreviewIndex(null);
    },

    openPreview(item) {
      if (this.$route.query.templateId != item.Id) {
        var query = Object.assign({}, this.$route.query);
        query.templateId = item.Id;
        this.$router.replace({ query });
        if (this.isPhoneBool) { this.$store.state.triggerevents.previewTrigger++; }
      }
    },
    closePreview() {
      if (this.$route.query.templateId != undefined) {
        var query = Object.assign({}, this.$route.query);
        query.templateId = undefined;
        this.$router.replace({ query });
        if (this.isPhoneBool) { this.$store.state.triggerevents.previewTrigger++; }
      }
    },

    openItem(item) {
      var query = (this.$route.name == "AdminCheckLists") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewCheckList', params: { templateId: item.Id }, query })
    },

    setEditItem(item) {
      this.dialogtrigger++;
      this.editItem = item;
    },

    newEditItem() {
      var obj = Object.assign({}, this.newItemInitial);
      console.log(obj, this.templateTypes);
      this.setEditItem(obj);
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.newEditItem(); }
  },
};
</script>